export default __webpack_public_path__ + "static/media/penink05.3f1a59a0.png";